/* eslint-disable quote-props */
/**
 * Layouts are mainly helper classes for visuals to display label data and have
 * data on for displaying labels and providing boundary data.
 */
export default class BaseLayout {
  /**
   * Adds a layout group to the layout container and render the labels in
   * there.
   *
   * params {Array} layoutsContainer   D3 array of the layoutContainer
   */
  constructor(layoutsContainer) {
    this._layoutContainer = layoutsContainer.append('g').classed({
      'visual-layout': true,
      'hide': true,
    });

    this.labels.forEach(label => {
      this._layoutContainer.append('text').attr(label).text(label.text);
    });
  }

  /**
   * @return {array}  array of label information.
   */
  get labels() {
    return [
      /**
       * Example of a label.
       *
       * {
       *   x: 10,
       *   y: 15,
       *   class: 'my-label',
       *   text: 'myLabel'
       * }
       */
    ];
  }

  /**
   * @return {object}   key-pair lookup of section dimensions.
   */
  get sections() {
    return {
      /**
       * Example of a section. Should be a key-pair for lookup purposes.
       *
       * mySection: {
       *   x1: 22,
       *   x2: 200,
       *   y: 0,
       *   y2: 200,
       *   width: 0.2,
       *   height: 0.2
       * }
       */
    };
  }

  hide() {
    this._layoutContainer.classed('hide', true);
  }

  show() {
    this._layoutContainer.classed('hide', false);
  }
}
